// A player's fog on the floor in view (qa-runs#1160): their explored squares are kept per floor, the ground floor's in
// `explored` and each other floor they hold in `exploredOn` (`shared/src/state/floorFog.ts`). The board draws the
// floor in view with that floor's explored squares only; a floor they were sent nothing of is unexplored. Decides
// nothing: it picks among what the server sent.
import type { Span } from '@dragons-table/vtt-shared';

interface FloorFogLike { explored?: Span[]; exploredOn?: Record<string, Span[]> }

/** The fog to draw on `floor` (null, or the ground floor's id: the ground floor). Unchanged with no floors. */
export function fogOnFloor<F extends FloorFogLike>(fog: F, floor: string | null, groundId: string | null): F {
  if (!fog.exploredOn && (floor === null || floor === groundId)) return fog;
  const ground = floor === null || floor === groundId;
  return { ...fog, explored: ground ? fog.explored ?? [] : fog.exploredOn?.[floor!] ?? [] };
}
